import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IDepartment, IConnectionWithTotal } from '@api/types'
import { PageInfoFragment, DepartmentFragment } from '@api/fragments'

interface Payload {
  data: {
    viewer: {
      company: {
        departmentConnection: IConnectionWithTotal<IDepartment>
      }
    }
  }
}

export const departmentSearchQuery = gql`
  query DepartmentSearch($where: DepartmentWhereInput, $after: String) {
    viewer {
      company {
        departmentConnection(orderBy: name_ASC, first: 7, after: $after, where: $where) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...DepartmentFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${DepartmentFragment}
`

export default function search({
  query,
  after,
}: {
  query: string
  after?: string
}): Promise<IConnectionWithTotal<IDepartment>> {
  const variables = {
    after,
    where: { name_contains: query },
  }

  return client.gql.query({ query: departmentSearchQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { departmentConnection },
        },
      },
    }: Payload) => departmentConnection
  )
}
